import { render, staticRenderFns } from "./helpHome.vue?vue&type=template&id=01219a9a&scoped=true"
import script from "./helpHome.vue?vue&type=script&lang=js"
export * from "./helpHome.vue?vue&type=script&lang=js"
import style0 from "./helpHome.vue?vue&type=style&index=0&id=01219a9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01219a9a",
  null
  
)

export default component.exports